<template>
	<div>
		<default-widget-field v-bind="stripeFieldProps" v-on="defaultFieldListeners" />
		<div v-if="!isConfirming" :id="isReadOnly ? '' : 'stripe-checkout-container'"></div>
		<div v-else>
			<div>Checkout succeeded</div>
			<Lottie class="animation-container" :width="100" :options="completedAnimation" />
		</div>
	</div>
</template>

<script>
import DefaultWidgetField from './DefaultWidgetField';
import WidgetFieldMixin from './WidgetFieldMixin';
import { CONFIRMATION_REDIRECT_OPTIONS } from '../confirmation-mini-app.const';
import Lottie from '@/assets/lottie/lottie.vue';
import CalendlyConfirm from '@/components/BlockEditorWidget/WidgetFields/assets/calendly-confirm.json';
import WidgetFormService from '@/components/WidgetForm/WidgetFormService';

export default {
	name: 'StripeInputField',
	components: {
		DefaultWidgetField,
		Lottie,
	},
	props: {
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
		isReadOnly: { type: Boolean },
	},
	mixins: [WidgetFieldMixin],
	computed: {
		completedAnimation() {
			return { animationData: CalendlyConfirm, loop: false };
		},
		metadataOptions() {
			return this.field.metadata.options;
		},
		currentPreviousSteps() {
			return this.previousSteps || this.flatPreviousSteps;
		},
		stripeKey() {
			return WidgetFormService.processPreviousSteps(this.metadataOptions.stripe_key.value, this.currentPreviousSteps);
		},
		clientSecret() {
			return WidgetFormService.processPreviousSteps(this.metadataOptions.client_secret.value, this.currentPreviousSteps, {}, [], true);
		},
		stripeInstance() {
			return this.stripeKey ? window.Stripe(this.stripeKey) : null;
		},
		stripeFieldProps() {
			return { ...this.defaultFieldProps, titleEnabled: false };
		},
		confirmationHandlingOption() {
			return this.metadataOptions.confirmation_handling_option.value;
		},
	},
	methods: {
		onPaymentConfirm() {
			switch (this.confirmationHandlingOption) {
				case CONFIRMATION_REDIRECT_OPTIONS.withoutAnimation:
					this.value = {
						success: true,
					};
					this.$emit('on-mini-app-finished');
					break;
				case CONFIRMATION_REDIRECT_OPTIONS.defaultPage:
					this.$emit('disable-cancel-button');
					break;
				default:
					this.isConfirming = true;
					setTimeout(() => {
						this.value = {
							success: true,
						};
						this.$emit('on-mini-app-finished');
					}, 2000);
			}
			this.value = {
				success: true,
			};
			this.$emit('disable-cancel-button');
		},
	},
	async mounted() {
		if (this.clientSecret && !this.checkout && this.stripeKey && !this.isReadOnly) {
			this.checkout = await this.stripeInstance.initEmbeddedCheckout({
				fetchClientSecret: () => Promise.resolve(this.clientSecret),
				onComplete: this.onPaymentConfirm,
			});
			this.checkout.mount('#stripe-checkout-container');
		}
	},
	beforeDestroy() {
		if (this.checkout) {
			this.checkout.destroy();
		}
	},
	data: () => ({
		isConfirming: false,
		checkout: null,
	}),
};
</script>
<style scoped lang="scss"></style>
<style lang="scss"></style>
